import type { FC } from 'react';

import { ConfirmDialog } from '@revelio/ui';

interface ClearPageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ClearPageDialog: FC<ClearPageModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => (
  <ConfirmDialog
    open={isOpen}
    title="Clear all charts?"
    confirmLabel="Clear Page"
    destructive
    onConfirm={onConfirm}
    onCancel={onClose}
  >
    This will remove all charts from the current page. This action cannot be
    undone.
  </ConfirmDialog>
);
